export default {
	title: 'Definición del Colector',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		copy: 'Copiar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		getSuccess: 'Obtenido exitosamente',
		sendSuccess: 'Enviado exitosamente',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		terminalNumber: 'Número de Terminal',
		configName: 'Nombre de Configuración',
		selectTerminal: 'Seleccionar Terminal',
		config: 'Configuración',
		placeholder: {
			terminalNumber: 'Por favor ingrese número de terminal',
			configName: 'Por favor ingrese nombre de configuración',
			selectTerminal: 'Por favor seleccione terminal',
			config: 'Por favor seleccione configuración'
		}
	},
	table: {
		terminalNumber: 'Número de Terminal',
		configName: 'Configuración',
		sleepTimeDisplay: 'Tiempo de Sueño',
		specFreqDisplay: 'Frecuencia Espec',
		updateTime: 'Última Actualización'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		copy: 'Copiar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		terminalInfo: 'Información del Terminal',
		selfCheck: 'Autoevaluación del Terminal',
		checkInfo: 'Información de Verificación',
		getConfig: 'Obtener Configuración',
		check: 'Autoevaluación del Terminal'
	},
	widgetForm: {
		name: 'Nombre',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			name: 'Por favor ingrese nombre'
		}
	},
	terminal: {
		selectTerminal: 'Seleccionar Terminal',
		config: 'Configuración',
		sleepTime: 'Tiempo de Sueño',
		charValue: 'Valor Característico',
		wave: 'Onda',
		charValueLength: 'Longitud de Muestra del Valor Característico',
		charValueFreq: 'Frecuencia de Muestra del Valor Característico',
		highAccelLength: 'Longitud de Muestra de Aceleración Alta',
		highAccelFreq: 'Frecuencia de Muestra de Aceleración Alta',
		lowAccelLength: 'Longitud de Muestra de Aceleración Baja',
		lowAccelFreq: 'Frecuencia de Muestra de Aceleración Baja',
		longWaveLength: 'Longitud de Muestra de Onda Larga',
		longWaveFreq: 'Frecuencia de Muestra de Onda Larga',
		waveSampleInterval: 'Intervalo de Muestra de Onda',
		longWaveInterval: 'Intervalo de Onda Larga',
		rpmChannel1: 'Canal RPM 1',
		rpmChannel2: 'Canal RPM 2',
		waveChannel: 'Canal de Onda',
		channel: 'Canal',
		sensitivity: 'Sensibilidad',
		online: 'En Línea',
		offline: 'Fuera de Línea',
		normal: 'Normal',
		abnormal: 'Anormal'
	},
	configSection: {
		config: 'Configuración',
		sleepConfig: 'Configuración de Sueño',
		charValueConfig: 'Configuración de Valor Característico',
		waveConfig: 'Configuración de Onda',
		channelConfig: 'Configuración de Canal',
		collectLength: 'Longitud de Recolección',
		collectFreq: 'Frecuencia de Recolección',
		highLength: 'Longitud Alta',
		highFreq: 'Frecuencia Alta',
		lowLength: 'Longitud Baja',
		lowFreq: 'Frecuencia Baja',
		longLength: 'Longitud Larga',
		longFreq: 'Frecuencia Larga',
		waveInterval: 'Intervalo de Onda',
		longWaveInterval: 'Intervalo de Onda Larga',
		rpm1Channel: 'Canal RPM 1',
		rpm2Channel: 'Canal RPM 2',
		waveChannels: 'Canales de Onda'
	},
	timeUnit: {
		second: 's',
		minute: 'min',
		hour: 'h',
		day: 'd',
		s: 's',
		min: 'min',
		h: 'h',
		d: 'd'
	},
	buttons: {
		getConfig: 'Obtener Configuración',
		selfCheck: 'Autoevaluación',
		send: 'Enviar',
		setSensitivity: 'Configurar Sensibilidad',
		getWave: 'Obtener Onda',
		confirm: 'Confirmar',
		cancel: 'Cancelar'
	},
	options: {
		sleep: 'Tiempo de Sueño',
		spec: 'Valor Característico',
		wave: 'Forma de Onda',
		sleep_time: 'Tiempo de Sueño',
		spec_length: 'Longitud de Muestra del Valor Característico',
		spec_freq: 'Frecuencia de Muestra del Valor Característico',
		high_length: 'Longitud de Muestra de Aceleración Alta',
		high_freq: 'Frecuencia de Muestra de Aceleración Alta',
		low_length: 'Longitud de Muestra de Aceleración Baja',
		low_freq: 'Frecuencia de Muestra de Aceleración Baja',
		long_length: 'Longitud de Muestra de Onda Larga',
		long_freq: 'Frecuencia de Muestra de Onda Larga',
		wave_time: 'Intervalo de Muestra de Onda',
		long_wave_time: 'Intervalo de Onda Larga',
		rpm1: 'Canal RPM 1',
		rpm2: 'Canal RPM 2',
		channels: 'Canal de Forma de Onda',
		timeOptions: {
			'10s': '10s',
			'20s': '20s',
			'30s': '30s',
			'1min': '1min',
			'5min': '5min',
			'10min': '10min',
			'20min': '20min',
			'30min': '30min',
			'1h': '1h',
			'2h': '2h',
			'4h': '4h',
			'6h': '6h',
			'12h': '12h',
			'1d': '1d',
			'2d': '2d',
			'3d': '3d',
			'4d': '4d'
		},
		lengthOptions: {
			'1K': '1K',
			'2K': '2K',
			'4K': '4K',
			'8K': '8K',
			'16K': '16K',
			'32K': '32K',
			'64K': '64K',
			'128K': '128K',
			'256K': '256K',
			'512K': '512K',
			'2048K': '2048K'
		},
		freqOptions: {
			'2560': '2560',
			'5120': '5120',
			'12800': '12800',
			'25600': '25600',
			'51200': '51200'
		}
	}
}
